import React from 'react';
import AlertBase from '@mui/material/Alert';

const Alert = (props) => <AlertBase {...props} />;

export default Alert;
